import React from 'react';
import { Link } from 'react-router-dom';

export const ControlPanelPage: React.FC = () => {
  return (
    <div className="p-8">
      <h1 className="text-3xl font-bold mb-4">Painel de Controle</h1>
      <p className="text-gray-700 mb-6">Bem-vindo à área administrativa do Know inDoc. Aqui você pode gerenciar configurações globais, clientes, sistema, agentes, e muito mais.</p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-white rounded shadow p-6">
          <h2 className="text-xl font-semibold mb-2">Clientes</h2>
          <p className="text-gray-600 mb-2">Gerencie as empresas que utilizam a plataforma.</p>
          <Link to="/admin/customers" className="text-blue-600 hover:underline">Acessar módulo de clientes</Link>
        </div>
        <div className="bg-white rounded shadow p-6">
          <h2 className="text-xl font-semibold mb-2">Planos</h2>
          <p className="text-gray-600 mb-2">Gerencie os planos disponíveis na plataforma.</p>
          <Link to="/admin/plans" className="text-blue-600 hover:underline">Acessar módulo de planos</Link>
        </div>
        <div className="bg-white rounded shadow p-6">
          <h2 className="text-xl font-semibold mb-2">Perfis</h2>
          <p className="text-gray-600 mb-2">Gerencie os perfis de acesso ao sistema.</p>
          <Link to="/admin/roles" className="text-blue-600 hover:underline">Acessar módulo de perfis</Link>
        </div>
        <div className="bg-white rounded shadow p-6">
          <h2 className="text-xl font-semibold mb-2">Configurações do Sistema</h2>
          <p className="text-gray-600 mb-2">Ajuste parâmetros globais da plataforma.</p>
          <Link to="/admin/settings" className="text-blue-600 hover:underline">Acessar configurações</Link>
        </div>
        {/* Adicione mais cards conforme necessário */}
      </div>
    </div>
  );
}; 